import { ConfigStore } from "fs-pb-vue2/store/modules/config";
import { Prop, Ref } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { OperationVue } from "fs-pb-vue2/vueModels/operations/OperationVue";
import { CardModel } from "fs-pb-vue2/models/contracts/cardModel";
import { ContractsStore } from "fs-pb-vue2/store/modules/contracts";
import { container } from "@/inversify.config";
import { DiTokens } from "fs-pb-vue2/services/diTokens";
import IOperationService from "fs-pb-vue2/services/operations/IOperationService";
import IAlertService from "fs-pb-vue2/services/alert/IAlertService";
import { CashBackCategoryModel } from "../../models/cardOperations/CashBackCategoryModel";
import { ContractsApi } from "fs-pb-vue2/services/api/ContractsApi";

 export class CashBackModalVue extends OperationVue {

  // services:

  /**
 * Сервис уведомлений
 * @returns {IAlertService}
 */
  get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }

  /**
 * Сервис проведения операций каталога
 * @returns {IOperationService}
 */
  get operationService(): IOperationService {
    return container.get<IOperationService>(DiTokens.CashBackSelectService);
  }

  // stores:

  /**
 * Хранилище конфигураций
 * @returns {ConfigStore}
 */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  /**
 * Хранилище счетов
 * @returns {ContractsStore}
 */
  get contractsStore(): ContractsStore {
    return getModule(ContractsStore, this.$store);
  }

  // props:

  /** Входные параметры */
  @Prop() data!: CardModel;

  /** Входные параметры */
  @Prop() params!: any;

  // data:

  //selectedCategories: Array<any> = [];
  selectedCategories: Array<CashBackCategoryModel> = [];
  readonly: boolean = true;

  // Данные для модального окна
  isModalOpen: boolean = false;
  modalTitle: string = '';

  handleYes: () => void;
  handleNo: () => void;

  // computed:

  /**
   * Код операции
   * @returns {string} - код для отправки апи.
   */
   get respondentCode(): string {
    return this.configStore.apiData.OperationSelectCategoryCashBack;
  }

  //get selectCategory() {
  get selectCategory(): Array<CashBackCategoryModel> {
    if (this.params.card.Data.selectMode == 2) {
      this.readonly = false;
      return this.params.card.Data.categories;
    } else {
      this.readonly = true;
      return this.params.card.Data.currentCategories;
    }
  }

  // Получение названия текущего месяца
  get currentMonthName(): string {
    const date = new Date();
    return date.toLocaleString('ru-RU', { month: 'long' });
  }

  // methods:

  /** Инициализация формы */
  async init(): Promise<void> {
    await this.initOperation();
    this.initSelectedCategories();
  }

  onConfirm(): void {
    if (this.params.card.Data.selectMode != 2) {
      this.destroyForm();
      return;
    }

    this.confirmSelection();
  }

  initSelectedCategories(): void {
    this.selectedCategories = this.params.card.Data.categories.filter((category: any) => category.current);
    this.updateCategoryAvailability();
  }

  isCategorySelectable(category: any): boolean {
    return category.current || this.selectedCategories.includes(category) || this.selectedCategories.length < this.params.card.Data.maxCurrentCategoriesCount;
  }

  onCategoryCheck(category: any): void {
    const index = this.selectedCategories.findIndex((c) => c.caption === category.caption);

    if (index >= 0) {
      // Если категория уже выбрана, убираем её
      this.selectedCategories.splice(index, 1);
    } else if (this.selectedCategories.length < this.params.card.Data.maxCurrentCategoriesCount) {
      // Если категория еще не выбрана и лимит не достигнут, добавляем её
      this.selectedCategories.push(category);
    }

    // Обновляем состояние всех категорий
    this.updateCategoryAvailability();
  }

  updateCategoryAvailability(): void {
    const maxReached = this.selectedCategories.length >= this.params.card.Data.maxCurrentCategoriesCount;

    this.params.card.Data.categories.forEach((category: any) => {
      if (!this.selectedCategories.includes(category)) {
        // Если лимит достигнут и категория не выбрана, скрываем чекбокс
        category.disabled = maxReached;
        category.hidden = maxReached;
      } else {
        // Если лимит не достигнут или категория выбрана, показываем чекбокс
        category.disabled = false;
        category.hidden = false;
      }
    });
  }

  async showModal(title: string): Promise<boolean> {
    return new Promise((resolve) => {
      this.modalTitle = title;
      this.isModalOpen = true;

      this.handleYes = () => {
        this.isModalOpen = false;
        resolve(true);
      };

      this.handleNo = () => {
        this.isModalOpen = false;
        resolve(false);
      };
    });
  }

  async confirmSelection(): Promise<void> {
    this.OperationModel.selectedCategories = this.selectedCategories;
    if (this.params.card.Data.selectMessage && this.params.card.Data.selectMessage.trim()) {
      const accept = await this.showModal(this.params.card.Data.selectMessage);
      if (!accept) {
        return;
      }
    }
    await this.next()
  }

  /**Следующий шаг операции */
  async next(): Promise<void> {
    try {
      this.execLoading = true;
      this.OperationModel = await this.service.nextStep(this.OperationModel);
      if (this.OperationModel.IsSuccess || this.OperationModel.IsExecuting || this.OperationModel.IsError) {
        await this.service.afterExecute(this.OperationModel);
        await this.afterExecute();
      }
      await ContractsApi.getCardAsync(this.params.card.Data.Id);
      this.execLoading = false;
    }
    catch (e) {
      this.execLoading = false;
      throw e;
    }
  }

  /** Инициализация операции */
  async initOperation(): Promise<void> {
    this.loading = true;
    this.service = container.get<IOperationService>(DiTokens.CashBackSelectService);
    this.OperationModel = (await this.operationService.init({
      code: this.respondentCode,
      card: this.params.card,
      contract: this.params.contract,
      selectedCategories: this.selectedCategories
    })) as CashBackCategoryModel;
    this.loading = false;
  }
}